<template lang="pug">
v-tab-item
    feathers-vuex-find(service="bh-promo-codes" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
        v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
            v-card-title Code Lists
                v-spacer
                v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search Code" single-line hide-details)
                dialog-add-code(@success="$emit('success')" @error="$emit('error', $event)")
            v-data-table(
                :headers="headers"
                :loading="isFindPending"
                :items="isFindPending ? [] : desserts"
                :options.sync="pagination"
                :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
                :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
                loading-text="Fetching Data..."
            )

                template(v-slot:item.badge="{ item }")
                    img(:src="item.badge" width="40")

                //- template(v-slot:item.artist_name="{ item }")
                //-     v-avatar(size="30" style="margin-right: 10px;")
                //-         img(:src="item.profile_picture_thumb")
                //-     a(:href="`http://www.breakinghits.app/${item.url}`" :target="`__user-${item.id}`") {{ item.artist_name }}
                //- template(v-slot:item.date_added="{ item }") {{ item.date_added | dateFormat }}
                template(v-slot:item.actions="{ item }")
                    div(style="display: flex; gap: 8px; justify-content: flex-end; flex-wrap: wrap;")
                        dialog-show-qr-code(:item="item")
                        promo-analytics(:item="item")
                        dialog-add-code(:item="item")
                        dialog-delete(:item="item" @success="successMessage = true")

    v-snackbar(top v-model="successMessage" color="success") Successfully Deleted!
    v-snackbar(top v-model="error.show" color="red") {{ error.message }}

</template>

<script>
import moment from 'moment';
import DialogAddCode from './DialogAddCode.vue';
import DialogShowQrCode from './DialogViewQRCode.vue';
import DialogDelete from './DialogDelete.vue';
import PromoAnalytics from './PromoAnalytics.vue';

export default {
    data() {
        return {
            searchUser: '',
            successMessage: false,
            error: {
                show: false,
                message: ''
            },
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                    width: 30
                },
                {
                    text: 'Badge',
                    align: 'start',
                    sortable: false,
                    value: 'badge',
                    width: 50
                },
                {
                    text: 'Code',
                    align: 'start',
                    sortable: true,
                    value: 'code'
                },
                {
                    text: 'Description',
                    align: 'start',
                    sortable: true,
                    value: 'description'
                },
                {
                   text: 'Date Created',
                    align: 'end',
                    sortable: true,
                    value: 'createdAt'
                },
                {
                    text: 'Actions',
                    align: 'end',
                    sortable: false,
                    value: 'actions',
                    width: 400
                }
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['createdAt'],
                sortDesc: [true]
            },
            query: {},
        };
    },
    filters: {
        dateFormat(date) {
            if(date) {
                return moment(date).format('lll');
            }

            return 'n/a';
        },
        status(status) {
            switch(status) {
                case 0: return 'Inactive';
                case 1: return 'Active';
            }
        }
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    // id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { code: { $like: `%${this.searchUser}%` } },
                    ]
                };
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { code: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                    ]
                };
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                // $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
    },
    methods: {
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
    },
    components: {
        DialogAddCode,
        DialogShowQrCode,
        DialogDelete,
        PromoAnalytics
    }
}
</script>